"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleCommentingDialog = void 0;
var single_commenting_dialog_component_1 = require("./single-commenting-dialog.component");
Object.defineProperty(exports, "SingleCommentingDialog", { enumerable: true, get: function () { return single_commenting_dialog_component_1.SingleCommentingDialog; } });
